import React from "react";
import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Button from "@components/Button";
import SectionHeader from "../SectionHeader";
import BrandLogo from "../BrandLogo";
import "./style.scss";
import { useNavigate } from "react-router";
import DOMPurify from "dompurify";

export default NiceModal.create(() => {
  const modal = useModal();
  const navigate = useNavigate();

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      onAfterClose={() => modal.remove()}
      innerClass={"redeem-award-modal"}
    >
      <SectionHeader>
        <p
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(modal.args?.title ?? ""),
          }}
        ></p>
      </SectionHeader>
      <div className="desktop-wrapper">
        <div className="img-wrapper">
          <img src={modal.args?.bg} alt="" />

          <BrandLogo />
        </div>
        <div className="copy">
          <p
            className="award-name"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(modal.args?.awardName ?? ""),
            }}
          />
          {modal.args?.awardDesc && (
            <p
              className="award-desc"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(modal.args?.awardDesc),
              }}
            />
          )}
        </div>
      </div>
      <div className="buttons-wrapper">
        <Button
          action={() => {
            navigate("/coupons/received", { replace: true });
            modal.hide();
          }}
        >
          {modal.args.emailTicket ? "Vielen Dank" : "Vielen Dank"}
        </Button>
      </div>
    </Modal>
  );
});
